import { FC } from 'react';
import {
    MdOutlineAttachFile,
    MdOutlineDescription,
    MdOutlineEdit,
    MdOutlineInfo,
    MdOutlineOpenInNew,
    MdOutlineRemoveRedEye,
    MdSearch,
} from 'react-icons/md';
import { IDocumentTable } from '@models/Forms/IForms';
import { resolveUrlTemplate } from '@utils/urlTemplate';
import { TableRow } from './tableColumns';

/** Иконка кнопки из конфигурации (previewDocIcon). Имена достались от DevExtreme
 *  (`dx-icon-<name>`) — переводим ходовые в наш набор, незнакомое имя не должно
 *  оставлять кнопку без значка, поэтому падаем на «открыть». */
const PREVIEW_ICONS: Record<string, typeof MdSearch> = {
    find: MdSearch,
    search: MdSearch,
    doc: MdOutlineDescription,
    file: MdOutlineDescription,
    edit: MdOutlineEdit,
    info: MdOutlineInfo,
    eyeopen: MdOutlineRemoveRedEye,
    attach: MdOutlineAttachFile,
};

/** Ссылка «просмотреть документ строки» (previewDocByKey/previewDocUrl) —
 *  паритет OpenDocButton старой ветки, но без DX-иконок. */
const OpenDocButton: FC<{ table: IDocumentTable; row: TableRow; docId?: string }> = ({ table, row, docId }) => {
    const docIdRow = table.previewDocByKey ? row[table.previewDocByKey] : undefined;
    const url = table.previewDocUrl
        ? resolveUrlTemplate(table.previewDocUrl, { docId, row })
        : docIdRow
          ? `/document/${String(docIdRow)}`
          : undefined;
    if (!url) return null;
    const title = table.previewDocTitle || 'Просмотреть';
    const Icon = (table.previewDocIcon && PREVIEW_ICONS[table.previewDocIcon]) || MdOutlineOpenInNew;
    return (
        <a
            href={url}
            className="tdn-opendoc"
            title={title}
            aria-label={title}
            target="_blank"
            rel="noopener noreferrer"
        >
            <Icon size="16" />
        </a>
    );
};

export default OpenDocButton;
